import { transformBrand } from '@shared/utils/transformBrand'

/**
 * Google Tag Manager container IDs by canonical brand key (after `transformBrand`).
 * These are public container IDs (not secrets); add a row when a new canonical brand gets its own
 * GTM container. Variants ('cw', 'wm', 'ev', etc.) collapse to a canonical key via `transformBrand`.
 */
const GTM_CONTAINER_ID_BY_THEME_BRAND: Record<string, string> = {
  sir: 'GTM-WLKWX7ZZ',
  ebac: 'GTM-53DHMZ22',
  // si: add when container ID is defined
}

/**
 * Resolves the GTM container ID for the active theme brand, or `undefined` if none is configured.
 * Brand variants ('cw' → 'sir', 'wm'/'ev' → 'ebac') resolve to the canonical key via
 * `transformBrand` so themed sites share their canonical brand's GTM container.
 */
export function getGtmContainerIdForThemeBrand(themeBrand: string | undefined): string | undefined {
  const normalized = themeBrand?.trim().toLowerCase()
  if (!normalized) return undefined
  return GTM_CONTAINER_ID_BY_THEME_BRAND[transformBrand(normalized)]
}
